import { useTranslation } from '@axo/shared/i18n';
import SwitchUI from '@axo/shared/ui/input/lib/Switch/SwitchUI';
import { Controller, useFormContext } from 'react-hook-form';
import { useReloadValue } from '../../hooks';
import { IControlledField, IField } from '../UI.types';

interface ISwitchField<Fields>
  extends IField<Fields>,
    IControlledField<Fields> {
  label?: string;
  description?: string;
  rules?: any; // TODO add correct type
  'data-testid'?: string;
}

export function SwitchFieldUI<Fields>({
  name,
  description,
  rules,
  tooltipValidation,
  ...props
}: ISwitchField<Fields>) {
  const { t } = useTranslation();

  let tooltip = '';

  const { control } = useFormContext();

  useReloadValue(name);

  if (
    tooltipValidation &&
    tooltipValidation.message &&
    typeof tooltipValidation.message === 'string'
  ) {
    tooltip = t(tooltipValidation.message);
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <SwitchUI
          onBlur={onBlur}
          onChange={onChange}
          checked={value}
          tooltip={tooltip}
          state="undetermined-with-tooltip"
          {...props}
        >
          {description}
        </SwitchUI>
      )}
    />
  );
}
